import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsDutyApi,
  IAboutUsDutyApiRequest,
  IAboutUsDutyApiGetAllAttrs,
  IAboutUsDutyApiGetAllResponse,
  IAboutUsDutyApiGetAttrs,
  IAboutUsDutyApiGetResponse,
  IAboutUsDutyApiSaveAttrs,
  IAboutUsDutyApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/duty/about-us-duty-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsDutyApi extends BaseApi<IAboutUsDutyApi> implements IAboutUsDutyApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_DUTY_URL
  private aboutUsDutyUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home banners
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsDutyApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsDutyApiGetAllResponse>} Promise<IAboutUsDutyApiGetAllResponse>
   */
  async aboutUsDuty_getAboutUsDuties(payload: IAboutUsDutyApiGetAllAttrs): Promise<IAboutUsDutyApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsDutyUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsDutyApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsDutyApiGetResponse>} Promise<IAboutUsDutyApiGetResponse>
   */
  async aboutUsDuty_getAboutUsDuty(payload: IAboutUsDutyApiGetAttrs): Promise<IAboutUsDutyApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsDutyUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsDutyApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsDutyApiSaveResponse>} Promise<IAboutUsDutyApiSaveResponse>
   */
  async aboutUsDuty_saveAboutUsDuty(payload: IAboutUsDutyApiSaveAttrs): Promise<IAboutUsDutyApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.aboutUsDutyUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
